export const PROFILE_MAX_LENGTH = 750;

export enum EditProfileFormSectionKeys {
  BUSINESS_NAME = "business-name-section",
  CATEGORY = "category-section",
  DESCRIPTION = "description-section",
  ADDRESS = "address-section",
  PHONE_NUMBERS = "phone-numbers-section",
  WEBSITE = "website-section",
  OPEN_INFO = "open-info-section",
  REGULAR_HOURS = "regular-hours-section",
  SPECIAL_HOURS = "special-hours-section",
  SOCIAL_LINKS = "social-links-section",
}
